import { Row } from '@/shared/components/layout';

import { CountriesList } from './countries';

/**
 * @deprecated Use shared/components/Country
 */
export const resolveCountry = (key: string, withFallback = true, withIcon = true) => {
  const country = CountriesList.find((_country) => _country.key === key);

  if (!country) {
    return withFallback ? <span>Unknown country</span> : '';
  }

  return (
    <Row
      alignCenter
      gap={4}
      style={{ margin: 0, display: 'flex', flexWrap: 'nowrap', overflow: 'hidden' }}
    >
      {withIcon && (
        <span style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{country.icon}</span>
      )}
      <span>{country.label}</span>
    </Row>
  );
};
